class FloatingAtc extends HTMLElement {
  connectedCallback() {
    const mainButton = document.querySelector('product-form button[name="add"]');
    if (!mainButton) return;
    this.menuBar = document.querySelector("mobile-menu-bar");
    this.isActive = false;
    this.lastScrollY = window.scrollY;
    this.footerVisible = false;
    this.mainButton = mainButton;
    this.buttonObserver = new IntersectionObserver(
      ([entry]) => {
        const scrolledPast = entry.boundingClientRect.bottom < 0;
        this.isActive = !entry.isIntersecting && scrolledPast;
        if (!this.isActive) {
          this.hide();
          this.showMenuBar();
        } else if (!this.footerVisible) {
          this.updateVisibility();
        }
      },
      { threshold: 0 }
    );
    const footer = document.querySelector("footer");
    if (footer) {
      this.footerObserver = new IntersectionObserver(
        ([entry]) => {
          this.footerVisible = entry.isIntersecting;
          if (entry.isIntersecting) {
            this.hide();
            this.hideMenuBar();
          } else if (this.isActive) {
            this.updateVisibility();
          }
        },
        { threshold: 0.1 }
      );
      this.footerObserver.observe(footer);
    }
    this.onScroll = () => {
      if (!this.isActive || this.footerVisible) return;
      const scrollY = window.scrollY;
      const scrollingDown = scrollY > this.lastScrollY;
      this.lastScrollY = scrollY;
      if (scrollingDown) {
        this.show();
        this.hideMenuBar();
      } else {
        this.hide();
        this.showMenuBar();
      }
    };
    this.buttonObserver.observe(mainButton);
    window.addEventListener("scroll", this.onScroll, { passive: true });
  }
  show() {
    this.style.transform = "translateY(0)";
    this.style.bottom = "0";
  }
  hide() {
    this.style.transform = "translateY(100%)";
    this.style.bottom = "";
  }
  showMenuBar() {
    if (this.menuBar) {
      this.menuBar.style.transform = "";
    }
  }
  hideMenuBar() {
    if (this.menuBar) {
      this.menuBar.style.transform = "translateY(calc(100% + 30px))";
    }
  }
  updateVisibility() {
    this.show();
    this.hideMenuBar();
  }
  disconnectedCallback() {
    this.buttonObserver?.disconnect();
    this.footerObserver?.disconnect();
    window.removeEventListener("scroll", this.onScroll);
    this.showMenuBar();
  }
}
window.customElements.define("floating-atc", FloatingAtc);
